import {
    Button,
    Card,
    Grid,
    InputAdornment,
    Table,
    TableContainer,
    TableHead,
    TextField,
    Typography,
    TableRow,
    TableBody,
    Box,
    TablePagination,
    Divider,
    FormControl,
    Select,
    MenuItem,
    Tooltip,
    ListSubheader,
    IconButton
} from '@mui/material';
import { ChangeEvent, useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { AppActions } from 'src/store/AppReducer';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import { withStyles } from '@mui/styles';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { DatePicker } from '@mui/lab';
import moment from 'moment';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { getAllEmployeesFilter } from 'src/services/employeeService';
import { getEvents } from "src/services/EventService";
import { deleteEvent } from "src/services/EventService";
import { getEventDetails } from "src/services/EventService";
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import RecordAttendance from './RecordAttendance';
import {
    getAttendanceListByEventId,
    saveAttendanceList
} from 'src/services/AttendanceService';
import { Attendee } from './interface/Attendee';
import { validateMultiRolesAndPermissions } from "src/utils/validate";
import { getRolePermissions } from "src/services/authService";
import EventToggleModal from './EventToggleModel';
import DownloadAttendance from './DownloadAttendance';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PreviewToggleModal from './PreviewToggleModel';
import { useAppSelector } from 'src/hooks/hooks';
import { EventDetails } from './interface/EventDetails';


const ViewEvent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [events, setEvents] = useState([]);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('');
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [searchString, setSearchString] = useState('');
    const [toggleFilter, setToggleFilter] = useState(false);
    const [recordCount, setRecordCount] = useState<number>(0);
    const [filterEventDate, setFilterEventDate] = useState<string | null>(null);
    const [filterFacilitator, setFilterFacilitator] = useState('');
    const currentYear = new Date().getFullYear();
    const [page, setPage] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    const [userRole, setUserRole] = useState<string | null>(null);
    const [facilitatorList, setFacilitatorList] = useState([]);
    const [open, setOpen] = useState(false);
    const [editEventId, setEditEventId] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [openAttendance, setOpenAttendance] = useState(false);
    const [eventAttendees, setEventAttendees] = useState<Attendee[]>([]);
    const [permissions, setPermissions] = useState([]);
    const [isFilterDisabled, setIsFilterDisabled] = useState(true);
    const [isFilterCleared, setIsFilterCleared] = useState(false);
    const [searchText, setSearchText] = useState('');

    const toggle = () => setOpen(false);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [eventId, setEventId] = useState(0);

    const previewToggle = () => setPreviewOpen(false);
    const [attendanceFlags, setAttendanceFlags] = useState<{ [eventId: number]: boolean }>({});
    const handleSnackbarMessage = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
        setSnackBarMessage(message);
        setSnackbarSeverity(severity);
        setSnackBarOpen(true);
    };

    const { isLoading } = useAppSelector((state) => state.appReducer);
    const [openConfirmationCustomerDelete, setOpenConfirmationCustomerDelete] = useState(false);
    const [deleteEventId, setDeleteEventId] = useState(0);
    const [deleteEventDetails, setDeleteEventDetails] = useState<EventDetails>(null);

    const filteredFacilitators = facilitatorList.filter((item) =>
        item.name.toLowerCase().includes(searchText.toLowerCase())
    );

    const toggleConfirmationCustomerDelete = () => {
        setOpenConfirmationCustomerDelete(!openConfirmationCustomerDelete);
    };

    const cellStyle = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    };

    const handleRecordAttendance = async (item: any) => {

        if (!item?.id) {
            return;
        }

        try {

            const res = await getAttendanceListByEventId(item.id);

            const attendees = res?.data?.data || [];

            const transformed = attendees.map((a: any, index: number) => ({
                tempId: a.id && a.id !== 0 ? a.id : -(index + 1),
                actualId: a.id,
                name: a.employeeName,
                participation: a.participations,
                employeeId: a.employeeId,
                eventId: a.eventId
            }));


            setEventAttendees(transformed);


            const isExistingAttendance = transformed.some(
                (a: any) => !!a.participation && a.participation !== 'N/A'
            );
            setIsEdit(isExistingAttendance);


            setAttendanceFlags((prev) => ({
                ...prev,
                [item.id]: isExistingAttendance
            }));

            setOpenAttendance(true);
        } catch (err) {
            setSnackBarMessage('Failed to fetch attendance data');
            setSnackbarSeverity('error');
            setSnackBarOpen(true);

        }
    };

    const originalAttendeeOrderRef = useRef<Map<string, number>>(new Map());

    useEffect(() => {
        if (
            eventAttendees.length > 0 &&
            !originalAttendeeOrderRef.current.size
        ) {
            const map = new Map<string, number>();
            eventAttendees.forEach((attendee, index) => {
                map.set(attendee.employeeId, index);
            });
            originalAttendeeOrderRef.current = map;
        }
    }, [eventAttendees]);


    const getPermissions = (mail) => {
        getRolePermissions(mail)
            .then((res) => {
                const tabs = validateMultiRolesAndPermissions(res);
                const arr = tabs.filter((fil) => fil.name === 'Event Management');

                if (arr.length > 0) {
                    setPermissions(arr.length > 0 ? arr[0].permissions : []);
                } else {
                    setPermissions([]);
                }
            })
            .catch((error) => {
                setSnackBarMessage('Failed to fetch permissions');
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
                setPermissions([]);
            });
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (Object.keys(user).length === 0) {
            navigate('/');
        } else {
            getPermissions(user.Email);
        }
    }, [navigate]);

    const CustomTableRow = withStyles({
        root: {
            background: '#E6E9FF !important',
            height: '3.5rem',
            width: '4.2rem'
        }
    })(TableRow);

    const getEventList = async () => {
        try {
            const res = await getEvents({
                pageNo: page,
                pageSize: limit,
                eventName: searchString,
                facilitator: filterFacilitator,
                date: filterEventDate
            });

            if (res?.data?.statusCode === 200) {
                const data = res?.data?.data || {};

                setEvents(data.events || []);
                setRecordCount(data.totalCount || 0);



                const attendanceChecks: { eventId: number; isMarked: boolean }[] = await Promise.all(
                    (data.events || []).map(async (event) => {
                        try {
                            const attendanceRes = await getAttendanceListByEventId(event.id);
                            const attendeeList = attendanceRes?.data?.data || [];
                            const isMarked = attendeeList.some(
                                (a) => !!a.participations && a.participations !== 'N/A'
                            );
                            return { eventId: event.id, isMarked };
                        } catch (error) {

                            return { eventId: event.id, isMarked: false };
                        }
                    })
                );


                const updatedFlags: { [eventId: number]: boolean } = {};
                attendanceChecks.forEach((check) => {
                    updatedFlags[check.eventId] = check.isMarked;
                });

                setAttendanceFlags(updatedFlags);
                dispatch(AppActions.hideLoader());

            } else {

                setSnackBarMessage('Failed to retrieve events.');
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
                setEvents([]);
                dispatch(AppActions.hideLoader());
            }
        } catch (error) {

            console.error('Error loading events:', error);
            setSnackBarMessage('Failed to retrieve employee events.');
            setSnackbarSeverity('error');
            setSnackBarOpen(true);
            setEvents([]);
            dispatch(AppActions.hideLoader());
        }
    };

    const getAttendanceTooltip = (
        eventId: number,
        attendanceFlags: { [key: number]: boolean },
        attendanceList: any[]
    ): string => {
        if (attendanceFlags[eventId] !== undefined) {
            return attendanceFlags[eventId] ? 'Edit Attendance' : 'Record Attendance';
        }

        const hasParticipation = Array.isArray(attendanceList) &&
            attendanceList.some((a) => a.participations && a.participations !== 'N/A');

        return hasParticipation ? 'Edit Attendance' : 'Record Attendance';
    };



    const fetchEmployeesLists = async () => {
        try {
            const res = await getAllEmployeesFilter([], []);
            const employeesLists = res?.data?.employees || [];
            setFacilitatorList(employeesLists);
        } catch (error) {
            setFacilitatorList([]);
        }
    }

    useEffect(() => {
        dispatch(AppActions.showLoader());
        dispatch(AppActions.toggleSnackBarClose());
        const user = localStorage.getItem('user');
        const parsed = user ? JSON.parse(user) : null;
        setUserRole(parsed?.Roles || null);
        fetchEmployeesLists();
    }, []);

    useEffect(() => {
        getEventList();
        setPage(0);
    }, [searchString]);

    useEffect(() => {
        getEventList();
    }, [page, limit]);

    useEffect(() => {
        if (editEventId != '') {
            setOpen(true);
        }
    }, [editEventId]);

    useEffect(() => {
        if (!open) {
            setEditEventId('');
        }
    }, [open]);

    const handlePageChange = (event: any, newPage: number): void => {
        setPage(newPage);
    };

    const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setPage(0);
        setLimit(parseInt(event.target.value));
    };

    useEffect(() => {
        if (isFilterCleared) {
            getEventList();
        }
        setIsFilterCleared(false);
    }, [filterEventDate, filterFacilitator]);

    const onClear = () => {
        setFilterEventDate('');
        setFilterFacilitator('');
        setPage(0);
        setIsFilterCleared(true);
        setIsFilterDisabled(true);
    };

    const onFilter = () => {
        setPage(0);
        getEventList();
    };

    useEffect(() => {
        if (!open || !snackBarOpen) {
            getEventList();
        }
    }, [open, snackBarOpen]);

    const formatTo12Hour = (time: String) => {
        const [hours, minutes] = time.split(":");
        const date = new Date();
        date.setHours(Number(hours), Number(minutes));

        const options: Intl.DateTimeFormatOptions = {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };

        return date.toLocaleTimeString("en-US", options);
    };

    function convertToDDMMYYYY(dateStr: string): string {
        const [year, month, day] = dateStr.split('-');
        return `${day}/${month}/${year}`;
    }

    const cancelEvent = () => {
        toggleConfirmationCustomerDelete();
        dispatch(AppActions.showLoader());
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        getEventDetails(deleteEventId).then((response) => {
            const res = response?.data?.data;

            const body = {
                id: res.id,
                eventName: res.eventName,
                date: res.date,
                audience: res.audience,
                facilitator: res.facilitator,
                facilitatorEmail: res.facilitatorEmail,
                venue: res.venue,
                description: res.description,
                timeFrom: res.timeFrom,
                timeTo: res.timeTo,
                msTeamsEventId: res.msTeamsEventId,
                inviteUserEmails: res.inviteUserEmails,
                groupIds: res.groupIds,
                optionalInviteUserEmails: res.optionalInviteUserEmails,
                optionalGroupIds: res.optionalGroupIds,
                reminderMinutes: 15
            };

            if (new Date(body.date.toString()) > yesterday) {
                deleteEvent(body).then(async (res) => {
                    if (res?.data?.statusCode === 200) {
                        dispatch(AppActions.hideLoader());
                        setSnackBarMessage('Event successfully cancelled.');
                        setSnackbarSeverity('success');
                        setSnackBarOpen(true);
                    }
                })
                    .catch((error) => {
                        dispatch(AppActions.hideLoader());
                        setSnackBarMessage('Failed to cancel event.');
                        setSnackbarSeverity('error');
                        setSnackBarOpen(true);
                    });
            } else {
                dispatch(AppActions.hideLoader());
                setSnackBarMessage('This Event has already concluded.');
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
            }
        })

    }

    return (
        <>
            <Grid>
                <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
                    <Grid item>
                        <Typography
                            style={{
                                marginLeft: '0px',
                                fontWeight: '700',
                                fontSize: '16px',
                                fontFamily:
                                    'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                            }}
                        >
                            <span
                                style={{
                                    cursor: 'pointer',
                                    marginRight: '3px'
                                }}
                                onClick={() => {
                                    navigate('/event-management');
                                }}
                            >
                                Events
                            </span>
                        </Typography>
                        <Typography variant="subtitle2"></Typography>
                    </Grid>
                    <Grid item>
                        {permissions.some(
                            (perm) => perm.name === 'Create Event' && perm.value === true
                        ) && (
                                <Button
                                    sx={{
                                        mt: { xs: 2, md: 0 },
                                        fontSize: '11px',
                                        fontWeight: 'normal'
                                    }}
                                    variant="contained"
                                    style={{ height: '1.75rem' }}
                                    startIcon={<AddTwoToneIcon fontSize="small" />}
                                    onClick={() => setOpen(true)}
                                >
                                    Add New Event
                                </Button>
                            )}
                    </Grid>
                </Grid>
                <Card>
                    <Grid sx={{ m: 2 }}>
                        <TextField
                            sx={{ width: 320, mr: 2 }}
                            size="small"
                            placeholder="Event Name"
                            InputProps={{
                                style: { fontSize: '12px', height: '1.75rem' },
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            sx={{ color: '#d3d3d3' }}
                                            style={{ fontSize: '15px' }}
                                        />
                                    </InputAdornment>
                                )
                            }}
                            inputProps={{
                                maxLength: 255
                            }}
                            value={searchString}
                            onChange={(e) => {
                                setSearchString(e.target.value);
                            }}
                        />
                        <Button
                            sx={{
                                mt: { xs: 2, md: 0 },
                                color: `${!toggleFilter && 'gray'}`
                            }}
                            variant="outlined"
                            startIcon={<FilterListIcon style={{ fontSize: '15px' }} />}
                            style={{ height: '1.75rem', fontSize: '12px' }}
                            onClick={() => {
                                setToggleFilter(!toggleFilter);
                            }}
                        >
                            Filters
                        </Button>
                    </Grid>
                    {toggleFilter && (
                        <Grid px={2} pb={2} style={{ margin: 0 }}>
                            <Grid
                                container
                                spacing={2}
                                style={{
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    justifyContent: 'between'
                                }}
                            >
                                <Grid item xs={3}>
                                    <div style={{ marginTop: 7 }}>
                                        <FormControl fullWidth>
                                            <DatePicker
                                                InputProps={{
                                                    className: 'date-picker-leaveManagement'
                                                }}
                                                maxDate={new Date(currentYear, 11, 31)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            placeholder: 'Event Date',
                                                        }}
                                                    />
                                                )}
                                                value={filterEventDate ? filterEventDate : null}
                                                onChange={(newValue) => {
                                                    if (newValue) {
                                                        setFilterEventDate(moment(newValue).format('YYYY-MM-DD'));
                                                        setIsFilterDisabled(false);
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </div>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth>
                                        <Select
                                            sx={{ mt: 1 }}
                                            style={{
                                                fontSize: '12px',
                                                height: '2rem'
                                            }}
                                            fullWidth
                                            value={filterFacilitator || ' '}
                                            onChange={(e) => {
                                                setFilterFacilitator(e.target.value);
                                                setIsFilterDisabled(false);
                                            }}
                                            onClose={() => setSearchText('')}
                                            displayEmpty
                                        >
                                            <ListSubheader>
                                                <TextField
                                                    autoFocus
                                                    placeholder="Type to search..."
                                                    size="small"
                                                    fullWidth
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key !== 'Escape') {
                                                            e.stopPropagation();
                                                        }
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon fontSize="small" />
                                                            </InputAdornment>
                                                        ),
                                                        style: {
                                                            fontSize: '12px',
                                                            height: '32px',
                                                        },
                                                    }}
                                                />
                                            </ListSubheader>
                                            <MenuItem
                                                style={{ display: 'none' }}
                                                value=" "
                                                disabled
                                                hidden
                                            >
                                                <span style={{ color: '#a4a9b7' }}>
                                                    Facilitator
                                                </span>
                                            </MenuItem>
                                            {filteredFacilitators.map((item) => {
                                                return (
                                                    <MenuItem value={item.name} key={item.id}>
                                                        {item.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid
                                    item
                                    xs={9}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginLeft: 'auto'
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        style={{
                                            height: '1.75rem',
                                            fontSize: '12px'
                                        }}
                                        id="filterClear"
                                        disabled={isFilterDisabled}
                                        className={isFilterDisabled &&'clear-btn'}

                                        onClick={() => onClear()}
                                    >
                                        Clear
                                    </Button>
                                    <Button
                                        id="filterSubmit"
                                        variant="outlined"
                                        type="button"
                                        style={{
                                            height: '1.75rem',
                                            fontSize: '12px',
                                            marginLeft: '1rem'
                                        }}
                                        onClick={() => onFilter()}
                                        disabled={isFilterDisabled}
                                        className={isFilterDisabled &&'filter-btn'}
                                    >
                                        Filter
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    <Divider />
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <CustomTableRow>
                                    <TableHeaderCell content="Event Name" smallFont />
                                    <TableHeaderCell content="Date" smallFont />
                                    <TableHeaderCell content="Time" smallFont />
                                    <TableHeaderCell content="Audience" smallFont />
                                    <TableHeaderCell content="Facilitator" smallFont />
                                    <TableHeaderCell content="Venue" smallFont />
                                    <TableHeaderCell
                                        content="Action"
                                        smallFont
                                        sticky
                                        justifyContent
                                    />
                                </CustomTableRow>
                            </TableHead>
                            <TableBody>
                                {events.length !== 0 &&
                                    events.map((item) => {
                                        return (
                                            <TableRow key={item.id}>
                                                <TableColumnCell>
                                                    <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        gutterBottom
                                                        noWrap
                                                        sx={{ 
                                                            fontSize: '11px',
                                                            minWidth: 250,
                                                            maxWidth: 250,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                    >
                                                        {item?.eventName}
                                                    </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell>
                                                    <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        style={{ fontSize: '11px' }}
                                                        gutterBottom
                                                        noWrap
                                                    >
                                                        {convertToDDMMYYYY(item?.date)}
                                                    </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell>
                                                    <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        style={{ fontSize: '11px' }}
                                                        gutterBottom
                                                        noWrap
                                                    >
                                                        {formatTo12Hour(item?.time)}
                                                    </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell>
                                                    <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        gutterBottom
                                                        noWrap
                                                        sx={{ 
                                                            fontSize: '11px',
                                                            minWidth: 250,
                                                            maxWidth: 250,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                    >
                                                        {item?.audience}
                                                    </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell>
                                                    <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        style={{ fontSize: '11px' }}
                                                        gutterBottom
                                                        noWrap
                                                    >
                                                        {item?.facilitator ? item.facilitator : 'N/A'}
                                                    </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell>
                                                    <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        gutterBottom
                                                        noWrap
                                                        sx={{ 
                                                            fontSize: '11px',
                                                            minWidth: 250,
                                                            maxWidth: 250,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                    >
                                                        {item?.venue}
                                                    </Typography>
                                                </TableColumnCell>

                                                <TableColumnCell sticky justifyContent>
                                                    <Box
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="flex-start"
                                                        gap={1}
                                                    >
                                                        {permissions.some(
                                                            (perm) =>
                                                                perm.name === 'Preview Event' &&
                                                                perm.value === true
                                                        ) && (
                                                                <Tooltip title="Preview" placement="top">
                                                                    <Box
                                                                        display="flex"
                                                                        alignItems="center"
                                                                    >
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                setEventId(item?.id);
                                                                                setPreviewOpen(true);
                                                                            }}
                                                                            size="small"
                                                                        >
                                                                            <VisibilityIcon
                                                                                style={{
                                                                                    fontSize: '18px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Tooltip>
                                                            )}

                                                        {permissions.some(
                                                            (perm) =>
                                                                perm.name === 'Download Attendance' &&
                                                                perm.value === true
                                                        ) && (
                                                                <Box
                                                                    display="flex"
                                                                    alignItems="center"
                                                                >
                                                                    <DownloadAttendance
                                                                        eventId={item?.id}
                                                                        eventName={item?.eventName || ''}
                                                                        eventDate={item?.date || ''}
                                                                        eventTime={item?.time || ''}
                                                                        onMessage={handleSnackbarMessage}
                                                                    />
                                                                </Box>
                                                            )}

                                                        {permissions.some(
                                                            (perm) => perm.name === 'Record Attendance' && perm.value === true
                                                        ) && (
                                                                <Tooltip
                                                                    title={getAttendanceTooltip(item.id, attendanceFlags, item.attendanceList)}
                                                                    placement="top"
                                                                >
                                                                    <Box display="flex" alignItems="center">
                                                                        <IconButton
                                                                            onClick={() => handleRecordAttendance(item)}
                                                                            disabled={new Date().toISOString() < new Date(`${item?.date}T${item?.time}`).toISOString()}
                                                                            size="small"
                                                                        >
                                                                            <PostAddOutlinedIcon
                                                                                style={{
                                                                                    fontSize: '19px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Tooltip>

                                                            )}

                                                        {permissions.some(
                                                            (perm) =>
                                                                perm.name === 'Edit Event' &&
                                                                perm.value === true
                                                        ) && (
                                                                <Tooltip title="Edit" placement="top">
                                                                    <Box
                                                                        display="flex"
                                                                        alignItems="center"
                                                                    >
                                                                        <IconButton
                                                                             onClick={() => {
                                                                                setEditEventId(item?.id);
                                                                            }}
                                                                            size="small"
                                                                        >
                                                                            <EditIcon
                                                                                style={{
                                                                                    fontSize: '18px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Tooltip>
                                                            )}

                                                        {permissions.some(
                                                            (perm) => perm.name === 'Delete Event' && perm.value === true
                                                        ) && (
                                                                <Tooltip title="Delete" placement="top">
                                                                    <Box
                                                                        display="flex"
                                                                        alignItems="center"
                                                                    >
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                toggleConfirmationCustomerDelete();
                                                                                setDeleteEventId(item.id);
                                                                            }}
                                                                            size="small"
                                                                        >
                                                                            <DeleteOutlineIcon
                                                                                style={{
                                                                                    fontSize: '19px',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Tooltip>
                                                            )}
                                                    </Box>
                                                </TableColumnCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {events?.length === 0 && (
                        <Typography
                            style={{
                                fontSize: '15px',
                                fontWeight: 'bold',
                                margin: '1rem',
                                textAlign: 'center'
                            }}
                            variant="body2"
                        >
                            No Events Found
                        </Typography>
                    )}
                    <Box p={2}>
                        <TablePagination
                            sx={{
                                fontSize: '12px',
                                '.MuiTablePagination-displayedRows': {
                                    fontSize: '12px'
                                },
                                '.MuiTablePagination-selectLabel': {
                                    fontSize: '12px'
                                }
                            }}
                            component="div"
                            count={recordCount}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleLimitChange}
                            page={page}
                            rowsPerPage={limit}
                            rowsPerPageOptions={[10, 20, 30, 40, 50]}
                        />
                    </Box>
                </Card>
                <EventToggleModal
                    open={open}
                    editEventId={editEventId}
                    toggle={toggle}
                />
                <PreviewToggleModal
                    previewOpen={previewOpen}
                    previewToggle={previewToggle}
                    eventId={eventId}
                />
                <ConfirmationModal
                    open={openConfirmationCustomerDelete}
                    toggle={toggleConfirmationCustomerDelete}
                    message={`Are you sure want to delete this event? This action cannot be undone. `}
                    onConfirm={() => cancelEvent()}
                    noToggle={toggleConfirmationCustomerDelete}
                    isLoading={isLoading}
                />

                {openAttendance && (
                    <RecordAttendance
                        open={openAttendance}
                        onClose={() => setOpenAttendance(false)}
                        attendees={eventAttendees}
                        onSave={async (updatedList) => {
                            try {
                                dispatch(AppActions.showLoader());

                                const payload = updatedList.map((attendee) => ({
                                    id: attendee.actualId === 0 ? null : attendee.actualId,
                                    eventId: attendee.eventId,
                                    employeeId: attendee.employeeId,
                                    employeeName: attendee.name,
                                    participations: attendee.participation ?? 'N/A'
                                }));

                                await saveAttendanceList(payload);

                                if (updatedList.length > 0) {
                                    const eventId = updatedList[0].eventId;
                                    const refreshed = await getAttendanceListByEventId(eventId);
                                    const attendees = refreshed?.data?.data || [];
                                    const originalOrderMap = new Map<string, number>();
                                    attendees.forEach((attendee, index) => {
                                        originalOrderMap.set(attendee.employeeId, index);
                                    });
                                    originalAttendeeOrderRef.current = originalOrderMap;

                                    const transformed = attendees.map((a: any, index: number) => ({
                                        tempId: a.id || -(index + 1),
                                        actualId: a.id,
                                        name: a.employeeName,
                                        participation: a.participations,
                                        employeeId: a.employeeId,
                                        eventId: a.eventId
                                    }));

                                    setEventAttendees(transformed);


                                    const hasMarked = transformed.some(
                                        (a: any) => !!a.participation && a.participation !== 'N/A'
                                    );
                                    setAttendanceFlags((prev) => ({
                                        ...prev,
                                        [eventId]: hasMarked
                                    }));
                                }

                                const isNewAttendance = updatedList.every(attendee => !attendee.actualId);

                                setSnackBarMessage(
                                    isNewAttendance
                                        ? 'Attendance recorded successfully!'
                                        : 'Attendance updated successfully!'
                                );
                                setSnackbarSeverity('success');
                            } catch (err) {
                                console.error('Error submitting attendance:', err);
                                setSnackBarMessage('Failed to update attendance');
                                setSnackbarSeverity('error');
                            } finally {
                                dispatch(AppActions.hideLoader());
                                setSnackBarOpen(true);
                                setOpenAttendance(false);
                            }
                        }}
                    />


                )}

                <SnackBar
                    snackBarOpen={snackBarOpen}
                    setSnackBarOpen={setSnackBarOpen}
                    snackBarMessage={snackBarMessage}
                    snackbarSeverity={snackbarSeverity}
                />
            </Grid>
        </>
    );
};


export default ViewEvent;
